// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__15Clr","content":"ManualTimeModal_content__1Ois3"};